/** Hotel subpackage messages — English */
export default {
  hotel: {
    nav: {
      home: 'Hotels',
      list: 'Hotel list',
      detail: 'Hotel details',
      order: 'Create booking',
      search: 'Select location',
      evaluate: 'Reviews',
      facilities: 'Facilities',
      highlights: 'Highlights & facilities',
      cart: 'Favorites',
      intlSearch: 'Intl. hotel location',
      intlCitySearch: 'Select intl. city',
      intlOrderDetail: 'Intl. hotel order',
    },
    common: {
      domestic: 'Domestic',
      international: 'International',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkInOutSame: 'Check-in/out',
      nights: '{count} night(s)',
      nightOne: '{count} night(s)',
      priceStar: 'Price & stars',
      searchHistory: 'Recent searches',
      clear: 'Clear',
      done: 'Done',
      cancel: 'Cancel',
      retry: 'Retry',
      locating: 'Locating…',
      locationFailedPrefix: 'Location failed, defaulting to ',
      locatedTo: 'Located at',
      searchPlaceholderDomestic: 'Area, brand, or hotel',
      searchPlaceholderIntl: 'City or hotel name',
      roomCount: '{room} room(s), {adult} adult(s), {child} child(ren)',
      featured: 'Featured',
      topHotels: 'Top hotels',
      guessYouLike: 'For you',
      reputationHot: 'Top rated',
      hotArea: 'Popular area',
      userChoiceRate: '{rate} | chosen by users',
      installmentFree: 'Interest-free installments',
      support40Banks: '40+ supported banks',
      queryHotel: 'Search hotels',
      searchHotel: 'Search hotels',
      proximitySearch: 'Search nearby',
      tabHome: 'Home',
      tabOrders: 'Orders',
      tabMine: 'Profile',
      currentLocation: 'Current location',
      adBannerTitle: 'Installments · Deals · Stay with confidence',
      locationFailedRetry: 'Location failed, try again later',
      cityType: 'City',
      china: 'China',
      searchResults: 'Results',
      hotDomesticCities: 'Popular cities',
      currentLocationLabel: 'Current location',
      searchCityPlaceholder: 'Search city name',
      service: 'Support',
      viewRoomTypes: 'View rooms',
      priceFrom: 'from',
      useful: 'Helpful',
      filter: 'Filter',
      all: 'All',
      withMedia: 'With photos/video',
      badReview: 'Negative',
      noPhone: 'No phone number available',
      pleaseLogin: 'Please sign in first',
      unfavoriteSuccess: 'Removed from favorites',
      favoriteSuccess: 'Added to favorites',
      loadSuccess: 'Loaded',
      loadFailedRetry: 'Load failed, please retry',
      shareUnlock: 'Unlock deal · {name}',
      taxIncluded: 'Tax incl.',
      noPrice: 'No quote',
      noMoreData: 'No more results',
      reviewsCount: '{count} reviews',
      scoreUnit: '{score}',
      tabFavorite: 'Favorites',
      tabMyOrders: 'My orders',
      checkInLabel: 'Check-in',
      checkOutLabel: 'Check-out',
      totalNights: '{count} night(s)',
      nightBadge: '{count} night(s)',
      clearHistory: 'Clear',
    },
    star: {
      below2: '2 stars or below',
      star3: '3 stars',
      star4: '4 stars',
      star5: '5 stars',
      economy: 'Budget',
      comfort: 'Comfort',
      upscale: 'Upscale',
      luxury: 'Luxury',
      below2List: '2 stars or below',
      star3List: '3 stars',
      star4List: '4 stars',
      star5List: '5 stars',
    },
    components: {
      selectDate: {
        title: 'Select dates',
      },
      houseDetail: {
        viewAllFacilities: 'View all facilities',
        collapse: 'Show less',
        policyAndService: 'Policies & services',
        beijingTime: 'Beijing time',
        cancelFee: 'Cancellation fee',
        nonRefundableNotice: 'If you do not check in, a fee of ¥{amount} applies. Your booking is subject to hotel or supplier confirmation; you will be notified by SMS or in-app message. If not confirmed, the full amount will be refunded.',
        cancellableNotice: '{rule}. After that, cancellation is not allowed; if you do not check in, a fee of ¥{amount} applies.',
        instantConfirmDesc: 'This room type can be confirmed quickly after booking',
        payOnlineDesc: 'Room rate must be paid in advance via bank card, UnionPay, etc.',
        costStayRange: '{start}–{end}, {nights}',
        roomFee: 'Room rate',
        packageTotal: 'Package total',
        perRoomPerNight: 'Per room per night',
        roomNightPrice: '{room} room(s), {night} night(s) ¥{amount}',
        roomNightSummary: '{room} room(s) · {night} night(s)',
        book: 'Book',
        avgPriceSummary: '{room} room(s), {night} night(s) avg.',
        floorSuffix: 'F',
        afterBookingSuccess: 'After booking confirmed',
        free: 'Free',
      },
      selectNum: {
        title: 'Rooms & guests',
        rooms: 'Rooms',
        adults: 'Adults',
        children: 'Children',
        childAgeHint: 'Ages 0–17',
      },
      filterPrice: {
        title: 'Price & star rating',
        price: 'Price',
        star: 'Star rating',
        clear: 'Clear',
        done: 'Done',
      },
    },
    positioning: {
      permissionTitle: 'Location permission',
      permissionContent: 'We need your location. Please enable location access in Settings.',
      confirmKnow: 'OK',
      geocodeFailed: 'Reverse geocoding failed, try again later',
      cityCodeFailed: 'City lookup failed',
    },
    list: {
      keywordPlaceholder: 'Keyword search',
      searchNameAddress: 'Search hotel name or address',
      unionOrderTip: 'Adding a hotel for your {type} booking',
      stayShort: 'In',
      leaveShort: 'Out',
      roomsUnit: '{count} room(s)',
      guestsUnit: '{count} guest(s)',
      roomGuestCompact: '{room} rm·{adult} pax',
      roomGuestsSummary: '{room} room(s), {adult} adult(s), {child} child(ren)',
      station: 'Station',
      locationDistance: 'Location & distance',
      priceStar: 'Price & stars',
      price: 'Price',
      star: 'Star rating',
      bookingInfo: 'Booking details',
      locate: 'Locate',
      distanceFromTarget: '{distance} km from {target}',
      you: 'you',
      smartSort: 'Recommended',
      priceAsc: 'Price: low to high',
      priceDesc: 'Price: high to low',
      starAsc: 'Stars: low to high',
      starDesc: 'Stars: high to low',
      distanceAsc: 'Distance',
      priceUp: 'Price ↑',
      priceDown: 'Price ↓',
      starUp: 'Stars ↑',
      starDown: 'Stars ↓',
      locationArea: 'Area',
      straightDistance: 'Distance',
      sort: 'Sort',
      bedType: 'Bed type',
      breakfast: 'Breakfast',
      hotelBadge: 'Hotel badge',
      filterLoadFailed: 'Failed to load filters',
      bedSingle: 'Single bed',
      bedTwin: 'Twin beds',
      bedKing: 'King bed',
      bedMulti: 'Multiple beds',
      bedKingTwin: 'King/twin',
      breakfastSingle: 'Single breakfast',
      breakfastDouble: 'Double breakfast',
      breakfastBed: 'Bed breakfast',
      breakfastNone: 'No breakfast',
      badgeGold: 'Gold',
      badgeSilver: 'Silver',
      badgeBronze: 'Bronze',
      unionOrderTypePlane: 'Flight',
      unionOrderTypeIntlPlane: 'Intl. flight',
      unionOrderTypeTrain: 'Train',
      unionOrderTypeFallback: 'Order',
      unionOrderFlightTrip: '{type} for {dep}–{arr}',
      unionOrderTrainTrip: '{type} for {from}–{to}',
      unionOrderDefault: 'Trip',
      locationTypeMetro: 'Metro lines',
      locationTypeTrainStation: 'Train stations',
      locationTypeUniversity: 'Universities',
      locationTypeHospital: 'Hospitals',
      locationTypeAttraction: 'Attractions',
      locationTypeAirport: 'Airports',
      locationTypeBusStation: 'Bus stations',
      geocodeAddressEmpty: 'Address is required',
      geocodeMapNotInit: 'Map API is not initialized',
      geocodeNotFound: 'Location not found',
      geocodeFailed: 'Geocoding failed',
      unionOrderCityLocked: 'City cannot be changed in bundle booking mode',
      enableLocation: 'Please enable location services',
      locateFailed: 'Location failed, try again later',
    },
    order: {
      roomDetail: 'Room details',
      nightsBadge: '{count} night(s)',
      instantConfirm: 'Instant confirmation',
      bookingInfo: 'Booking info',
      roomsUnit: '{count} room(s)',
      guestName: 'Guest name',
      guestNamePlaceholder: 'One guest name per room',
      guestInfo: 'Guest information',
      nameGuideTitle: 'Name guidelines:',
      lastNameGuide: 'Last name: English or pinyin, e.g. li',
      firstNameGuide: 'First name: English or pinyin, e.g. hao',
      roomGuestTitle: 'Guest for room {index}',
      fullName: 'Full name',
      fullNamePlaceholder: 'Enter full name',
      fullNamePlaceholderIntl: 'Full name (pinyin/English)',
      lastName: 'Last name',
      lastNamePlaceholder: 'e.g. li',
      firstName: 'First name',
      firstNamePlaceholder: 'e.g. hao',
      contactPhone: 'Mobile number',
      contactPhonePlaceholder: 'Enter mobile number',
      moreDiscount: 'More savings',
      coupon: 'Coupons',
      couponAvailable: '{count} available',
      couponNone: 'None available',
      bankPayLimit: 'Valid with {bank} payment only',
      designatedBank: 'designated bank',
      specialRequirements: 'Special requests',
      liftDistance: 'Elevator preference',
      smokeFree: 'Non-smoking room',
      moreRequirements: 'More requests',
      hotelTryBest: 'The hotel will try to meet your requests but cannot guarantee all.',
      agreePrefix: 'I have read and agree to the',
      privacyTitle: 'Personal information authorization',
      privacyPopupTitle: 'Privacy authorization',
      payOnline: 'Pay online',
      priceDetails: 'Price breakdown',
      priceDetailsShort: 'Details',
      payNow: 'Pay now',
      installmentPeriod: '{count} mo.',
      totalDiscount: 'Save ￥{amount}',
      requirePopupTitle: 'Special requests',
      requireTransmit: 'We will forward your requests to the hotel.',
      requireTryBest: 'The hotel will try to accommodate you but cannot guarantee all requests.',
      envRequirements: 'Environment & service',
      requirePlaceholder: 'Additional special requests',
      payOnlineDetail: 'Pay online',
      payLimit: 'Payment limit: {bank} only',
      privacyIntro: 'Thank you for using Interest-free travel hotel booking. The final service will be provided by the property.',
      privacyBody: "You understand that Interest-free travel must transmit the accommodation product information and personal information you provide (which may include name, contact details, ID, and payment information depending on the booking) to the service provider for order processing. For overseas hotels, this information may be transferred cross-border. Service providers may only use your information to fulfill the booking under applicable privacy laws. For questions about your personal information, contact privacy{'@'}ctrip.com. By submitting this order, you authorize Interest-free travel to share your information with relevant service providers for booking purposes.",
      phoneProtectTitle: 'Number protection:',
      phoneProtect1: '1. To protect your privacy during calls with the property, we may use virtual numbers so your real phone number is hidden.',
      phoneProtect2: '2. Number protection applies when:',
      phoneProtect2a: '(1) We provide a virtual number to the property during your stay; you may call back using the same virtual number.',
      phoneProtect2b: '(2) You call the property through Interest-free travel virtual calling.',
      phoneProtect3: '3. Protected calls may be recorded and stored in China for dispute resolution and legal compliance.',
      phoneProtect3a: '(1) Recordings may be used to resolve disputes between you and the property.',
      phoneProtect3b: '(2) Recordings may be disclosed when required by law.',
      phoneProtect4: '4. Service failures may temporarily expose your real number; recording may fail due to network or legal limits.',
      selectCoupon: 'Select coupon',
      loadingCoupons: 'Loading coupons…',
      noCoupons: 'No coupons available',
      skipCoupon: 'Do not use a coupon',
      discountUnit: ' off',
      validUntil: 'Valid until: {date}',
      liftFar: 'Away from elevator',
      liftNear: 'Near elevator',
      envSmokeFree: 'Non-smoking',
      envQuiet: 'Quiet room',
      envHighFloor: 'High floor',
      envNoCorner: 'Not a corner room',
      couponFetchFailed: 'Failed to load coupons',
      couponSelected: 'Coupon applied, save ￥{amount}',
      couponSelectFailed: 'Failed to apply coupon',
      couponCalcFailed: 'Failed to calculate discount',
      couponCancelled: 'Coupon removed',
      noThreshold: 'No minimum spend',
      couponReduce: 'Spend {min}, save {price}',
      couponInstantReduce: 'Save {price}',
      couponDiscount: 'Spend {min}, {discount}% off',
      couponInstantDiscount: '{discount}% off',
      couponDefault: 'Coupon',
      agreePrivacyFirst: 'Please read and agree to the privacy notice',
      guestPerRoom: 'Enter one guest name per room',
      fillContact: 'Please enter contact name and phone',
      completeGuestRoom: 'Complete guest info for room {index}',
      guestNameEnglishOnly: 'Room {index}: last/first name must be in English',
      fillPhone: 'Please enter mobile number',
      createOrderReturning: 'Returning to hotel details',
      createOrderFailed: 'Unable to create order',
      createOrderHotelLabel: 'Hotel',
      createOrderReturningIn: 'Returning in {seconds}s',
      createOrderReturnNow: 'Go back now',
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfterTomorrow: 'Day after',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat',
      monthDay: '{month}/{day}',
    },
    detail: {
      noRoomData: 'No room types available',
      bookOnlinePay: 'Book · pay online',
      book: 'Book',
      addCart: 'Add to cart',
      addingCart: 'Adding',
      addCartSuccess: 'Added to cart',
      addCartFailed: 'Unable to add to cart. Please retry.',
      cartQuoteInvalid: 'This rate is incomplete. Please select it again.',
      cartQuoteUpdated: 'This rate has changed. Please select it again.',
      loginFailed: 'Unable to open sign-in. Please retry.',
      reviewsCount: '{count} reviews',
      commentScoreEmptyTitle: 'No rating yet',
      commentScoreEmptyDesc: 'Stay with us and share your review.',
      guestRecommend: 'Guest favorite',
      facilities: 'Facilities',
      popularFacilities: 'Popular facilities',
      viewAll: 'View all',
      map: 'Map',
      roomFilter: 'Filter',
      bestSeller: 'Best seller',
      guessYouLike: 'Recommended for you',
      photosCount: '{count} photos',
      avgPrice: 'Avg ￥',
      viewMorePrices: '{count} more rates',
      noRooms: 'No rooms',
      noRoomTypesSoldOut: 'This hotel is sold out',
      soldOutLeadSeparator: ', ',
      soldOutSeeYouMayLike: 'See hotels you may like',
      allGuestReviews: 'All guest reviews',
      greatReviews: 'Great',
      goodRate: '{rate} positive',
      similarGuestReviews: 'Similar guests',
      viewAllReviews: 'All reviews',
      viewMediaReviews: 'Reviews with photos/video',
      guestQa: 'Guest Q&A',
      ask: 'Q',
      viewAllAnswers: 'View all {count} answers',
      hotelIntro: 'About this hotel',
      noIntro: 'No description',
      facilitiesService: 'Facilities & services',
      facilitiesScore: 'Facilities {score}',
      viewAllFacilities: 'All {count} facilities',
      hotelPolicy: 'Hotel policies',
      checkInOutTime: 'Check-in/out',
      checkInAfter: 'Check-in: after 14:00',
      checkOutBefore: 'Check-out: before 12:00',
      childrenPolicy: 'Children welcome',
      extraBed: 'Extra beds and cribs available',
      expandAllPolicy: 'All policies',
      youMayLike: 'You may also like',
      locationHighlightsTitle: 'Location highlights',
      surroundingsTitle: 'Nearby',
      distanceFromYou: '{distance} m from you ·',
      hotelPhone: 'Hotel phone',
      loadFailed: 'Load failed',
      loadFailedDesc: 'Network error or server busy. Please retry.',
      reload: 'Reload',
      childSuffix: ' child',
      roomGuestSummary: '{room} rm · {adult} guest(s)',
      indicationCover: 'Cover',
      indicationReviews: 'Reviews',
      indicationAlbum: 'Photos',
      ratingSuperb: 'Excellent',
      ratingGreat: 'Great',
      ratingVeryGood: 'Very good',
      ratingGood: 'Good',
      ratingOk: 'Fair',
      ratingFair: 'OK',
      distanceStraight: '{distance}{unit} from you',
      nightChip: '{count} nt',
      roomGuestCompact: '{room} rm · {adult} pax',
    },
    evaluate: {
      tabAllGuests: 'All guests {score}',
      tabSimilarGuests: 'Similar guests {score}',
      ratingGood: 'Very good',
      scoreExplanation: 'Rating info',
      hygiene: 'Cleanliness',
      environment: 'Environment',
      service: 'Service',
      facilities: 'Facilities',
      dimensionScore: '{name} {score}',
      newReviewer: 'New reviewer',
      checkInMeta: 'Stayed {month} · from {place}',
      familyTrip: 'Family trip',
    },
    highlights: {
      openingTime: 'Opened',
      roomCount: 'Rooms',
      roomsCount: '{count} room(s)',
      renovationTime: 'Renovated',
      starRating: 'Star rating',
      tabHighlights: 'Highlights',
      albumItem: '{label} ({count})',
    },
    facilities: {
      subtitle: 'Explore all amenities at this hotel',
      hotelEnvironment: 'Hotel photos',
      detailsTitle: 'Facility details',
      lowestPrice: 'Lowest price',
      pictureTypes: {
        restaurant: 'Restaurant',
        leisure: 'Leisure',
        meetingRoom: 'Meeting room',
        multiFunction: 'Multi-function hall',
        exterior: 'Exterior',
        lobby: 'Lobby / reception',
        fitness: 'Fitness & recreation',
        uncategorized: 'Uncategorized',
        lounge: 'Lounge / bar',
        other: 'Other',
        publicArea: 'Public areas',
        nearbyAttractions: 'Nearby attractions',
      },
      categories: {
        transport: 'Transportation Service',
        frontDesk: 'Front Desk Service',
        general: 'General Facilities',
        publicFacilities: 'Public Facilities',
        children: "Children's Facilities",
        business: 'Business Services',
        accessibility: 'Accessibility Services',
        sports: 'Sports',
        convenience: 'Convenience Facilities',
        entertainment: 'Recreation Facilities',
        childrenService: "Children's Services",
        toiletries: 'Bath Amenities',
        transportFacility: 'Transportation Facilities',
        networkComm: 'Internet & Communications',
        foodDrink: 'Food & Beverages',
        roomLayout: 'Room Layout & Furniture',
        roomLayoutAlt: 'Room Layout',
        network: 'Internet',
        outdoorView: 'Outdoor Scenery',
        otherService: 'Other Services',
        publicZone: 'Public Areas',
        leisureRecreation: 'Leisure & Entertainment',
        dining: 'Catering Services',
        wellness: 'Wellness Facilities',
        security: 'Safety & Security',
        mediaTech: 'Media & Technology',
        roomFacilities: 'Room Facilities',
        kitchen: 'Kitchenware',
        accessibilityAlt: 'Accessibility Facilities',
        cleaning: 'Cleaning Services',
        bathroom: 'Bathroom Facilities',
      },
    },
    map: {
      routeTooFar: 'Destination too far to route',
      routeNotFound: 'No route found',
      routePlanFailed: 'Routing failed, try again later',
      routeInvalid: 'Cannot route — check locations',
      routeNetworkError: 'Network error, routing failed',
      routeShown: 'Full route displayed',
      routeEmpty: 'No route information',
      destExpanded: 'Destination details expanded',
      destCollapsed: 'Destination details collapsed',
      panelExpanded: 'Navigation panel expanded',
      panelCollapsed: 'Navigation panel collapsed',
      modeSwitched: 'Switched to {mode}',
    },
  },
}
